<div class="compass-container">
  <svg viewBox="0 0 120 120" class="compass-svg">
    <defs>
      <filter id="gloss-blur" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
      </filter>
    </defs>

    <!-- Aro exterior base (siempre visible) -->
    <circle cx="60" cy="60" r="42" class="compass-ring-path" />

    <!-- Grupo principal centrado en (60, 60) con coordenadas relativas -->
    <g transform="translate(60, 60)">
      <g class="main-rotation-group" [style.transform]="'rotate(' + compassRotation + 'deg)'">
        <!-- Círculo gloss border -->
        <circle
          cx="0"
          cy="0"
          r="24"
          class="gloss-border"
          [class.mode-3d]="is3DMode"
          [class.disabled]="!enable3DButton && !is3DMode"
          filter="url(#gloss-blur)" />

        <!-- Círculo central clickable (botón 2D/3D) -->
        <circle
          cx="0"
          cy="0"
          r="21"
          class="center-disk"
          [class.mode-3d]="is3DMode"
          [class.disabled]="!enable3DButton && !is3DMode"
          (click)="onCenterButtonClick($event)" />

        <!-- Botones de orientación - SIEMPRE VISIBLES -->
        <g
          *ngFor="let dir of ['N', 'E', 'S', 'W']; let i = index"
          (click)="selectOrientation(dir); $event.stopPropagation()"
          class="label-group"
          [class.active]="selectedOrientation === dir"
          [class.is-north]="dir === 'N'"
          [class.disabled]="!availableOrientations[dir]">
          <!-- Grupo rotado para posicionar el elemento -->
          <g [style.transform]="'rotate(' + i * 90 + 'deg)'">
            <g transform="translate(0, -38)">
              <!-- Si es Norte (N), mostrar flecha roja apuntando hacia fuera -->
              <g *ngIf="dir === 'N'" transform="rotate(180) scale(0.85)">
                <path
                  d="M -10.2 -8.8 L -1.5 11.2 C -0.8 12.9 0.8 12.9 1.5 11.2 L 10.2 -8.8 C 11 -10.8 9.4 -12.7 7.6 -11.8 L 0.8 -8.2 C 0.3 -7.9 -0.3 -7.9 -0.8 -8.2 L -7.6 -11.8 C -9.4 -12.7 -11 -10.8 -10.2 -8.8 Z"
                  class="north-arrow" />
              </g>
              <!-- Para E, S, W: círculo de fondo -->
              <circle *ngIf="dir !== 'N'" cx="0" cy="0" r="10" class="label-bg" />
            </g>
          </g>
        </g>

        <!-- Textos de orientación FUERA del grupo rotado (siempre horizontales) -->
        <g *ngFor="let dir of ['N', 'E', 'S', 'W']; let i = index">
          <text
            *ngIf="dir !== 'N'"
            [attr.x]="getOrientationX(i)"
            [attr.y]="getOrientationY(i)"
            class="label-text"
            text-anchor="middle"
            dominant-baseline="middle"
            pointer-events="none">
            {{ dir }}
          </text>
        </g>
      </g>

      <!-- Texto 2D/3D centrado y fijo (NO rota) -->
      <text x="0" y="0" class="mode-text" [class.disabled]="!enable3DButton && !is3DMode" text-anchor="middle" dominant-baseline="middle">
        {{ is3DMode ? "3D" : "2D" }}
      </text>
    </g>
  </svg>

  <!-- Tooltips overlays (HTML elements for proper tooltip functionality) -->
  <div class="tooltip-overlay center-tooltip" [matTooltip]="mode3DTooltip || ''" [matTooltipDisabled]="!mode3DTooltip" matTooltipPosition="right"></div>

  <div
    *ngFor="let dir of ['N', 'E', 'S', 'W']; let i = index"
    class="tooltip-overlay orientation-tooltip"
    [class.orientation-n]="dir === 'N'"
    [class.orientation-e]="dir === 'E'"
    [class.orientation-s]="dir === 'S'"
    [class.orientation-w]="dir === 'W'"
    [style.transform]="'rotate(' + (i * 90 + compassRotation) + 'deg)'"
    [matTooltip]="orientationTooltips[dir] || ''"
    [matTooltipDisabled]="!orientationTooltips[dir]"
    matTooltipPosition="right"></div>
</div>
